exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Primary */\n/* Support */\n/* Attention */\n/* Other colors e.g. graphs */\n/* Text */\n/* Statuses */\n/* Tooltip */\n/* Toast a.k.a. notes */\n/* Pseudo classes */\n/* Backgrounds */\n/* Buttons */\n/* Date picker */\n/* Select */\n/* Grids */\n\n/* Primary */\n/* Support */\n/* Attention */\n/* Other colors e.g. graphs */\n/* Text */\n/* Statuses */\n/* Tooltip */\n/* Toast a.k.a. notes */\n/* Pseudo classes */\n/* Backgrounds */\n/* Buttons */\n/* Date picker */\n/* Select */\n/* Grids */\n\n.responsive-navbar-container {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  background-color: white;\n  min-width: 200px;\n  color: #67707c; }\n  .responsive-navbar-container .responsive-navbar-item {\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    border: none;\n    background-color: transparent;\n    outline: none; }\n    .responsive-navbar-container .responsive-navbar-item:focus {\n      box-shadow: none;\n      outline: none; }\n  .responsive-navbar-container .no-item-border {\n    border-bottom: 2px solid transparent; }\n  .responsive-navbar-container .inactive-border {\n    border-bottom: 2px solid #D3DADE; }\n  .responsive-navbar-container .selected-border {\n    box-shadow: none;\n    border-bottom: 2px solid #EC6608; }\n  .responsive-navbar-container .responsive-navbar-item-text {\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    margin: 0 5px 0 5px; }\n  .responsive-navbar-container .responsive-navbar-select {\n    font-weight: inherit;\n    font-size: inherit;\n    height: inherit;\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    margin: 0;\n    min-width: 200px;\n    max-width: 300px; }\n    .responsive-navbar-container .responsive-navbar-select .selected-border {\n      border-bottom: 2px solid #EC6608; }\n  .responsive-navbar-container .responsive-navbar-container-left {\n    padding-left: 1rem;\n    margin-right: auto; }\n  .responsive-navbar-container .responsive-navbar-container-right {\n    margin-left: auto; }\n", ""]);

// exports
exports.locals = {
	"colorPrimaryOrange": "#EC6608",
	"colorPrimaryYellow": "#FECA1D",
	"colorPrimarAzure": "#67707c",
	"colorBackgroundAside": "#EAEFF3",
	"colorBackgroundMenu": "#3C4A55",
	"colorMain": "#EC6608",
	"colorBlack": "#000000",
	"colorPetrol": "#006070",
	"colorDarkSteel": "#3B4A56",
	"colorSupportGray": "#CCCCCC",
	"colorLightGray": "#D3DADE",
	"colorAttentionRed": "#DD2515",
	"colorAttentionGreen": "#3AA57B",
	"colorYellow": "#FECA1D",
	"colorOrange": "#E66608",
	"colorGreen": "#3AA57B",
	"colorAzure": "#67707C",
	"colorGray": "#CCCCCC",
	"colorRed": "#D82515",
	"colorBlue": "#16AED6",
	"colorViolet": "#943BA3",
	"colorWhite": "#FFFFFF",
	"colorText": "#67707c",
	"colorTextLink": "#EC6608",
	"colorTextDisabled": "#a7a7a7",
	"colorWarning": "#FECA1D",
	"colorSuccess": "#3AA57B",
	"colorError": "#D82515",
	"colorInfo": "#16AED6",
	"colorTooltipText": "#FFFFFF",
	"colorTooltipBackground": "#006070",
	"colorToastText": "#000000",
	"colorToastBackground": "#eaeaea",
	"colorPseudoNormal": "#67707c",
	"colorPseudoFocused": "#FECA1D",
	"colorPseudoHover": "#FECA1D",
	"colorPseudoPressed": "#FECA1D",
	"colorPseudoDisabled": "#a7a7a7",
	"colorContentBackground": "#FFFFFF",
	"colorSiteBackground": "#D3DADE",
	"colorButtonText": "#FFFFFF",
	"colorButtonTextDisabled": "#a7a7a7",
	"colorButtonNormal": "#67707c",
	"colorButtonFocused": "#67707c",
	"colorButtonHover": "#77818c",
	"colorButtonPressed": "#585F68",
	"colorButtonPriorityNormal": "#E66608",
	"colorButtonPriorityFocused": "#E66608",
	"colorButtonPriorityHover": "#ff7517",
	"colorButtonPriorityPressed": "#d35c0b",
	"colorButtonDisabled": "#f0f0f0",
	"colorDatePickerContent": "#E9E9E9",
	"colorSelectHover": "#eff2f4",
	"colorSelectSelected": "#e6e9eb",
	"colorGridText": "#67707c",
	"colorGridBorder": "#D3DADE",
	"colorGridBackground": "#FFFFFF",
	"colorGridStripe": "#D3DADE",
	"colorGridHighlight": "#eff2f4",
	"colorGridSelected": "#e6e9eb",
	"borderRadiusBase": "0",
	"borderRadiusLarge": "0",
	"borderRadiusSmall": "0",
	"heightNavbar": "40px",
	"spaceContent": "1rem",
	"radiusContent": "0.5rem",
	"radiusNavbar": "0",
	"sidemenuColorText": "#FFFFFF",
	"fontWeightLight": "300",
	"fontWeightNormal": "400",
	"fontWeightBold": "700",
	"fontSizeH1": "3.6rem",
	"fontSizeH2": "3rem",
	"fontSizeH3": "2.4rem",
	"fontSizeH4": "1.8rem",
	"fontSizeLarge": "1.8rem",
	"fontSizeMedium": "1.6rem",
	"fontSizeNormal": "1.4rem",
	"fontSizeSmall": "1.2rem",
	"marginContent": "10px"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader/lib??ref--3-2!../node_modules/sass-loader/lib/loader.js!../src/responsive-navbar.scss
// module id = 530
// module chunks = 0